/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// Redirect all pages to siddhantkhare.com
export const onClientEntry = () => {
  if (typeof window !== 'undefined' && window.location.hostname === 'siddhant-k-code.github.io') {
    const newUrl = `https://siddhantkhare.com${window.location.pathname}${window.location.search}${window.location.hash}`;
    window.location.replace(newUrl);
  }
};
